const { Component } = Shopware;

import template from './sw-cms-block-manufacturer-block.html.twig';

Component.register('sw-cms-block-manufacturer-block', {
    template
});
